import type { FunctionComponent, SVGProps } from "react"

import { palmCopy } from "../config/copy"

type SvgComponent = FunctionComponent<SVGProps<SVGSVGElement>>

interface PalmSummaryProps {
  typeText: string
  title: string
  description: string
  bgImage: string
  HandIcon: SvgComponent
  sectionName: string
  onAsk: () => void
}

/** Per-line "Written in the Lines" summary card + advisor CTA. Ported from Summary. */
export function PalmSummary({
  typeText,
  title,
  description,
  bgImage,
  HandIcon,
  sectionName,
  onAsk,
}: PalmSummaryProps) {
  const [before, after] = palmCopy.writtenTheLines.unlockExpert.split("{section}")

  return (
    <div className="mt-8 rounded-[32px] bg-dark-surface py-6">
      <div className="px-4">
        <p className="font-body text-sm text-purple-light/40">{typeText}</p>
        <h4 className="mb-4 mt-1 font-display text-2xl font-medium text-purple-light">{title}</h4>
        <p className="font-body text-base text-purple-light/70">{description}</p>
      </div>

      <div className="relative flex h-[340px] w-full flex-col">
        <img
          src={bgImage}
          alt=""
          className="pointer-events-none absolute inset-0 size-full object-contain"
        />
      </div>

      <div className="px-4">
        <div className="mb-6 h-px w-full bg-purple-light/10" />
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 [&_svg]:size-14">
            <HandIcon />
            <p className="text-left font-body text-sm text-purple-light/70">
              {before}
              <span className="font-medium text-white">{sectionName}</span>
              {after}
            </p>
          </div>
          <button
            type="button"
            onClick={onAsk}
            className="flex h-12 w-full max-w-[151px] items-center justify-center rounded-full bg-gradient-to-b from-peach to-purple-accent font-body text-base font-semibold text-white transition-opacity hover:opacity-80"
          >
            {palmCopy.writtenTheLines.button}
          </button>
        </div>
      </div>
    </div>
  )
}
